export default "__VITE_ASSET__02f3557f__"